import axios from 'axios';

/*
 * Axios calls required by the Legacy Landing Page Submitted goal.
 *
 * These operations are against `LandingPageController` ein the infusionsoft module.
 */

const BASE_URL = '/app/landingPage';

export const getLandingPageSettings = async (landingPageId) => {
    const { data } = await axios.get(`${BASE_URL}/getLandingPageSettings/${landingPageId}`);

    return data;
};
